import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, ExpandAltOutlined, PlusOutlined, PlusSquareFilled } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Grid, Input, Modal, Row, Select, Space, Table, Tabs, type FormInstance, type TabsProps } from "antd";
import React, { useEffect, useState } from "react";
import type { IBeneficio, IComplementoBeneficio, ISelectList, ITipo, SimpleDropdownItem } from "../../../components/Interfaces";
import type { CheckboxProps } from "antd/lib";
import { errorMessage, successMessage } from "../../../messages/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListCheck, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import BeneficioComplemento from "./FormBeneficioComplemento";
import type { AlignType } from "rc-table/lib/interface";
import { hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";

interface IProps {
    form: FormInstance<any>;
    objetoBeneficio: IBeneficio[];
    setObjetoBeneficio: React.Dispatch<React.SetStateAction<IBeneficio[]>>;
    listTiposBeneficios: ITipo[];
    listRegimeFinanceiro: ISelectList[];
    listMetodoFinanciamento: ISelectList[];
    listTipoExpressaoBeneficio: ISelectList[];
    listPrazoPagamento: ISelectList[];
    listTipoRegraCalculo: SimpleDropdownItem[];
    listTipoRequisitoElegibilidade: SimpleDropdownItem[];
    manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const { useBreakpoint } = Grid;

const Beneficio = ({ form, objetoBeneficio, setObjetoBeneficio, listTiposBeneficios, listRegimeFinanceiro, listMetodoFinanciamento, listTipoExpressaoBeneficio, listPrazoPagamento, listTipoRegraCalculo, listTipoRequisitoElegibilidade, manter }: IProps) => {
    // const [form] = Form.useForm();
    const screens = useBreakpoint();

    const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
    const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
    const [exibirModalBeneficio, setExibirModalBeneficio] = useState(false);

    const [idBeneficioSelecionado, setIdBeneficioSelecionado] = useState("");
    const [tipoBeneficioId, setTipoBeneficioId] = useState("");
    const [regimeFinanceiro, setRegimeFinanceiro] = useState(0);
    const [nmRegimeFinanceiro, setNmRegimeFinanceiro] = useState("");
    const [metodoFinanciamento, setMetodoFinanciamento] = useState(0);
    const [tipoExpressaoBeneficio, setTipoExpressaoBeneficio] = useState(0);
    const [prazoPagamento, setPrazoPagamento] = useState(0);

    const [reservaAtuarialAcumulacao, setReservaAtuarialAcumulacao] = useState(false);
    const [reservaAtuarialConcessao, setReservaAtuarialConcessao] = useState(false);
    const [beneficioFacultativo, setBeneficioFacultativo] = useState(false);
    const [riscoSeguradora, setRiscoSeguradora] = useState(false);
    const [beneficioMinimo, setBeneficioMinimo] = useState(false);

    const [regrasCalculos, setRegrasCalculos] = useState<IComplementoBeneficio[]>([]);
    const [requisitosElegibilidade, setRequisitosElegibilidade] = useState<IComplementoBeneficio[]>([]);

    const [exibirBeneficiosCadastrados, setExibirBeneficiosCadastrados] = useState("none");

    useEffect(() => {
        if (manter === 2) { // Estamos no modo Detalhar
            setExibirElementoAcaoAlteracao("none");
        } else {
            setExibirElementoAcaoAlteracao("inline");
        }
    }, [manter])

    useEffect(() => {
        if (objetoBeneficio.length === 0) {
            setExibirBeneficiosCadastrados("none")
        } else {
            setExibirBeneficiosCadastrados("inline")
        }
    }, [objetoBeneficio]);

    useEffect(() => {
        if (estadoModal === 3) { // EM EDIÇÃO
            controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
        } else if (estadoModal === 2) { // EXIBIR DETALHES
            controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
        }
    }, [estadoModal])

    const setDadosBeneficio = () => {
        const currentForm = form.getFieldsValue();

        if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
            setObjetoBeneficio(pre => {
                return pre.map(beneficio => {
                    if (beneficio.emEdicao) {
                        return ({
                            id: idBeneficioSelecionado,
                            nome: currentForm.nmBeneficio.toUpperCase(),
                            regimeFinanceiro: regimeFinanceiro,
                            metodoFinanciamento: metodoFinanciamento,
                            tipoExpressaoBeneficio: tipoExpressaoBeneficio,
                            prazoPagamento: prazoPagamento,
                            reservaAtuarialAcumulacao: reservaAtuarialAcumulacao,
                            reservaAtuarialConcessao: reservaAtuarialConcessao,
                            beneficioFacultativo: beneficioFacultativo,
                            beneficioMinimo: beneficioMinimo,
                            riscoSeguradora: riscoSeguradora,
                            fundamentacaoRegulamentar: currentForm.fdRegulamentar.toUpperCase(),
                            beneficioExpresso: tipoExpressaoBeneficio,

                            tipoBeneficioId: tipoBeneficioId,

                            constReserva: undefined,
                            validado: undefined,
                            regrasCalculo: regrasCalculos.map((e: IComplementoBeneficio) => {
                                return {
                                    id: e.id,
                                    tipoRegraCalculoId: e.tipoComplementoId,
                                    marcadoParaExclusao: e.marcadoParaExclusao,
                                    tipoComplementoId: ""
                                };
                            }),
                            requisitosElegibilidade: requisitosElegibilidade.map((e: IComplementoBeneficio) => {
                                return {
                                    id: e.id,
                                    tipoRequisitoElegibilidadeId: e.tipoComplementoId,
                                    marcadoParaExclusao: e.marcadoParaExclusao,
                                    tipoComplementoId: ""
                                };
                            }),
                            emEdicao: false,
                            marcadoParaExclusao: false,
                        })
                    } else {
                        return beneficio
                    }
                })
            });
        } else {
            setObjetoBeneficio([
                ...objetoBeneficio,
                {
                    id: "",
                    nome: currentForm.nmBeneficio.toUpperCase(),
                    regimeFinanceiro: regimeFinanceiro,
                    metodoFinanciamento: metodoFinanciamento,
                    tipoExpressaoBeneficio: tipoExpressaoBeneficio,
                    prazoPagamento: prazoPagamento,
                    reservaAtuarialAcumulacao: reservaAtuarialAcumulacao,
                    reservaAtuarialConcessao: reservaAtuarialConcessao,
                    beneficioFacultativo: beneficioFacultativo,
                    beneficioMinimo: beneficioMinimo,
                    riscoSeguradora: riscoSeguradora,
                    fundamentacaoRegulamentar: currentForm.fdRegulamentar.toUpperCase(),
                    beneficioExpresso: tipoExpressaoBeneficio,

                    tipoBeneficioId: tipoBeneficioId,

                    constReserva: undefined,
                    validado: undefined,
                    regrasCalculo: regrasCalculos.map((e: IComplementoBeneficio) => {
                        return {
                            id: "", // EM UM NOVO BENEFÍCIOS, TODOS OS COPLEMENTOS SERÃO NOVOS TAMBÉM
                            tipoRegraCalculoId: e.tipoComplementoId,
                            marcadoParaExclusao: false,
                            tipoComplementoId: ""
                        };
                    }),
                    requisitosElegibilidade: requisitosElegibilidade.map((e: IComplementoBeneficio) => {
                        return {
                            id: "", // EM UM NOVO BENEFÍCIOS, TODOS OS COPLEMENTOS SERÃO NOVOS TAMBÉM
                            tipoRequisitoElegibilidadeId: e.tipoComplementoId,
                            marcadoParaExclusao: false,
                            tipoComplementoId: ""
                        };
                    }),
                    emEdicao: false,
                    marcadoParaExclusao: false,
                },
            ]);
        }
        limpaDados();
        setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
    }


    function gerarColunas() {
        let cols: any[] = [];

        cols.push(
            {
                title: "Nome do Benefício",
                dataIndex: "nome",
            });

        cols.push(
            {
                title: "Tipo",
                dataIndex: "",
                render: (ben: IBeneficio) => (
                    listTiposBeneficios.find(l => l.id === ben.tipoBeneficioId)?.nome
                )
            });

        cols.push({
            key: "9",
            title: "Opções",
            width: 40,
            dataIndex: "",
            align: 'center' as AlignType,
            render: (ben: IBeneficio) => (
                <>
                    <Space>
                        <div style={{ display: manter === 2 ? "inline" : "none" }}>
                            <ExpandAltOutlined
                                title="Detalhar"
                                style={{ color: "blue", marginLeft: 12 }}
                                onClick={() => {
                                    validaAlterarDetalharBeneficio(ben, 2);
                                }}
                            />
                        </div>

                        <div style={{ display: manter === 1 && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : exibirElementoAcaoAlteracao }}>
                            <EditOutlined
                                title="Editar"
                                style={{ color: "blue", marginLeft: 12 }}
                                onClick={() => {
                                    validaAlterarDetalharBeneficio(ben, 3);
                                    // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                                    objetoBeneficio.forEach(b => {
                                        if (b === ben) {
                                            b.emEdicao = estadoModal === 3 ? true : false;
                                        } else {
                                            b.emEdicao = false;
                                        }
                                    })
                                    ben.emEdicao = true;
                                }}
                            />

                            <DeleteOutlined
                                title="Excluir registro ainda não gravado na base."
                                style={{ color: "red", display: (ben?.id && ben?.id === "") ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                                onClick={() => {
                                    setObjetoBeneficio(objetoBeneficio.filter((b) => b !== ben));
                                }}
                            />
                        </div>

                        <div style={{ display: (ben?.id && ben?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
                            <>
                                <PlusSquareFilled
                                    title="Desmarcar para exclução"
                                    style={{ color: "blue", display: (ben.marcadoParaExclusao) ? "inline" : "none" }}
                                    onClick={() => {
                                        ben.marcadoParaExclusao = !ben.marcadoParaExclusao; // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                                        setObjetoBeneficio(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                                            return pre.map(b => {
                                                if (b.id === ben.id) {
                                                    return ben;
                                                } else {
                                                    return b;
                                                }
                                            });
                                        });
                                    }}
                                />
                            </>

                            <>
                                <DeleteOutlined
                                    title="Marcar para exclução/inativação"
                                    style={{ color: "red", display: (!ben.marcadoParaExclusao) ? "inline" : "none" }}
                                    onClick={() => {
                                        ben.marcadoParaExclusao = !ben.marcadoParaExclusao; // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                                        setObjetoBeneficio(pre => {
                                            return pre.map(b => {
                                                if (b.id === ben.id) {
                                                    return ben;
                                                } else {
                                                    return b;
                                                }
                                            });
                                        });
                                    }}
                                />
                            </>
                        </div>
                    </Space>
                </>
            ),
        })

        return cols.filter(Boolean);
    }
    const columns = gerarColunas();

    const handleCancel = () => {
        setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
        controleDaGrid("cancelar");
        limpaDados();
    };


    const validaInserirBeneficio = () => {
        form
            .validateFields()
            .then(() => {
                controleDaGrid("incluir Beneficio");
            })
            .catch((_error) => {
                errorMessage("Campo obrigatório não preechido");
            });
    }

    const controleDaGrid = (botao: string) => {
        if (botao === "cancelar") {
            setExibirModalBeneficio(false);
            setExibirElementoAcaoAlteracao("inline");
        } else if (botao === "incluir") {
            setExibirModalBeneficio(false);
            setExibirElementoAcaoAlteracao("inline");
        } else {
            setExibirModalBeneficio(true);
            setExibirElementoAcaoAlteracao("none");
        }

        if (manter === 2) { // Estamos no modo Detalhar
            setExibirElementoAcaoAlteracao("none");
        }
    };

    const handleTipoBeneficio = async (tpBen: any) => {
        setTipoBeneficioId(tpBen.key);
        form.setFieldsValue({
            "nmTpBeneficio": tpBen.value,
        })
    };

    const handleRegimeFinanceiro = async (regFin: any) => {
        setRegimeFinanceiro(regFin.value);
        setNmRegimeFinanceiro(regFin.label);
        form.setFieldsValue({
            "nmRegimeFinanceiro": regFin.label,
        })

        setMetodoFinanciamento(0);
        form.resetFields([
            "nmMetodoFinanciamento",
        ])

    };

    const handleMetodoFinanciamento = async (regFin: any) => {
        setMetodoFinanciamento(regFin.value);
        form.setFieldsValue({
            "nmMetodoFinanciamento": regFin.label,
        })
    };

    const handleTipoExpressaoBeneficio = async (tpEx: any) => {
        setTipoExpressaoBeneficio(tpEx.value);
        form.setFieldsValue({
            "nmTpExpressaoBeneficio": tpEx.label,
        })
    };

    const handlePrazoPagamento = async (prz: any) => {
        setPrazoPagamento(prz.value);
        form.setFieldsValue({
            "nmPrazoPagamento": prz.label,
        })
    };

    const onChangeReservaAtuarialAcumulacao: CheckboxProps['onChange'] = (e) => {
        setReservaAtuarialAcumulacao(e.target.checked);
    };
    const onChangeReservaAtuarialConcessao: CheckboxProps['onChange'] = (e) => {
        setReservaAtuarialConcessao(e.target.checked);
    };
    const onChangeBeneficioFacultativo: CheckboxProps['onChange'] = (e) => {
        setBeneficioFacultativo(e.target.checked);
    };
    const onChangeRiscoSeguradora: CheckboxProps['onChange'] = (e) => {
        setRiscoSeguradora(e.target.checked);
    };
    const onChangeBeneficioMinimo: CheckboxProps['onChange'] = (e) => {
        setBeneficioMinimo(e.target.checked);
    };

    const validarBeneficio = () => {
        let dadosValidados: Boolean = false;
        form
            .validateFields()
            .then(() => {
                if (!validarCampos()) {
                    return
                }
                dadosValidados = true;
                controleDaGrid("incluir");
                setDadosBeneficio();
                successMessage(manter === 3 ? "Benefício Alterado" : "Benefício Adicionado");
            })
            .catch((error) => {
                errorMessage(error.message);

                if (!dadosValidados) {
                    errorMessage("Campo obrigatório não preechido ou não validado");
                } else {
                    errorMessage(error.message);
                }
            });
    };

    function validarCampos(): boolean {

        if (tipoBeneficioId === "") {
            errorMessage("Tipo de Benefício não identificado");
            return false;
        }

        if (regimeFinanceiro === 0) {
            errorMessage("Regime Financeiro não identificado");
            return false;
        }

        if (metodoFinanciamento === 0 && nmRegimeFinanceiro.toUpperCase().includes("CAPTALIZAÇÃO")) {
            errorMessage("Método de financiamento não identificado");
            return false;
        }

        if (tipoExpressaoBeneficio === 0) {
            errorMessage("Tipo de Expressão do Benefício não identificado");
            return false;
        }

        if (prazoPagamento === 0) {
            errorMessage("Prazo de Pagamento não identificado");
            return false;
        }

        if (!regrasCalculos || regrasCalculos.length === 0) {
            errorMessage("Inclua pelo menos uma regra de cálculo");
            return false;
        }

        if (!requisitosElegibilidade || requisitosElegibilidade.length === 0) {
            errorMessage("Inclua pelo menos um requisito de elegibilidade");
            return false;
        }
        return true;

    }

    function limpaDados() {
        form.resetFields([
            "nmMetodoFinanciamento",
            "nmTpBeneficio",
            "nmBeneficio",
            "fdRegulamentar",
            "nmRegimeFinanceiro",
            "nmTpExpressaoBeneficio",
            "nmPrazoPagamento",
        ])
        setIdBeneficioSelecionado("");
        setTipoBeneficioId("");
        setRegimeFinanceiro(0);
        setNmRegimeFinanceiro("");
        setMetodoFinanciamento(0);
        setTipoExpressaoBeneficio(0);
        setPrazoPagamento(0);
        setReservaAtuarialAcumulacao(false);
        setReservaAtuarialConcessao(false);
        setBeneficioFacultativo(false);
        setRiscoSeguradora(false);
        setBeneficioMinimo(false);

        setRegrasCalculos([]);
        setRequisitosElegibilidade([]);

    }

    const validaAlterarDetalharBeneficio = (ben: IBeneficio, estado: number) => {
        form
            .validateFields()
            .then(() => {
                setFieldsDetalharEditar(ben);
                setEstadoModal(estado); // SET O MODO DETALHAR
            })
            .catch((_error) => {
                errorMessage("Campo obrigatório não preechido");
            });
    }

    const setFieldsDetalharEditar = (beneficio: IBeneficio) => {
        form.setFieldsValue({
            "nmMetodoFinanciamento": listMetodoFinanciamento.find(l => l.value === beneficio.metodoFinanciamento)?.label,
            "nmTpBeneficio": listTiposBeneficios.find(l => l.id === beneficio.tipoBeneficioId)?.nome,
            "nmBeneficio": beneficio.nome,
            "fdRegulamentar": beneficio.fundamentacaoRegulamentar,
            "nmRegimeFinanceiro": listRegimeFinanceiro.find(l => l.value === beneficio.regimeFinanceiro)?.value,
            "nmTpExpressaoBeneficio": listTipoExpressaoBeneficio.find(l => l.value === beneficio.tipoExpressaoBeneficio)?.label,
            "nmPrazoPagamento": listPrazoPagamento.find(l => l.value === beneficio.prazoPagamento)?.value,
        });

        setIdBeneficioSelecionado(beneficio.id);
        setTipoBeneficioId(beneficio.tipoBeneficioId);
        setRegimeFinanceiro(beneficio.regimeFinanceiro);
        setNmRegimeFinanceiro(listRegimeFinanceiro.find(l => l.value === beneficio.regimeFinanceiro)?.label || "");
        setMetodoFinanciamento(beneficio.metodoFinanciamento);
        setTipoExpressaoBeneficio(beneficio.tipoExpressaoBeneficio);
        setPrazoPagamento(beneficio.prazoPagamento);
        setReservaAtuarialAcumulacao(beneficio.reservaAtuarialAcumulacao);
        setReservaAtuarialConcessao(beneficio.reservaAtuarialConcessao);
        setBeneficioFacultativo(beneficio.beneficioFacultativo);
        setRiscoSeguradora(beneficio.riscoSeguradora);
        setBeneficioMinimo(beneficio.beneficioMinimo);

        setRegrasCalculos(
            beneficio.regrasCalculo.map(rc => {
                return {
                    id: rc.id,
                    marcadoParaExclusao: rc.marcadoParaExclusao,
                    tipoComplementoId: rc.tipoRegraCalculoId,
                } satisfies IComplementoBeneficio;
            })
        );

        setRequisitosElegibilidade(
            beneficio.requisitosElegibilidade.map(re => {
                return {
                    id: re.id,
                    marcadoParaExclusao: re.marcadoParaExclusao,
                    tipoComplementoId: re.tipoRequisitoElegibilidadeId,
                } satisfies IComplementoBeneficio;
            })
        );


    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Parâmetros de Cálculo',
            icon: <FontAwesomeIcon icon={faPiggyBank} />,
            children:
                <BeneficioComplemento
                    items={listTipoRegraCalculo}
                    tipo={1}
                    objetoTipo={regrasCalculos}
                    setObjetoTipo={setRegrasCalculos}
                    manter={manter}
                />
        },
        {
            key: '2',
            label: 'Requisitos de Elegibilidade',
            icon: <FontAwesomeIcon icon={faListCheck} />,
            children:
                <BeneficioComplemento
                    items={listTipoRequisitoElegibilidade}
                    tipo={2}
                    objetoTipo={requisitosElegibilidade}
                    setObjetoTipo={setRequisitosElegibilidade}
                    manter={manter}
                />

        }
    ];

    return (
        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

            <Button
                style={{ display: exibirElementoAcaoAlteracao }}
                id="incluirPlano"
                type="primary"
                shape="round"
                onClick={() => {
                    limpaDados();
                    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
                    validaInserirBeneficio();
                }}
                icon={<PlusOutlined />}
            >
                Incluir Benefício
            </Button>
            <>

                <Modal title={estadoModal === 3 ? "Alterar Beneficio" : (estadoModal === 2 ? "Detalhar Benefício" : "Incluir Benefício")} open={exibirModalBeneficio}
                    style={{ top: 20 }}
                    width={screens.xs ? 750 : 1000}
                    destroyOnHidden={true}
                    // onCancel={() => {
                    //     controleDaGrid("cancelar");
                    //     limpaDados();
                    // }}
                    closable={false}
                    // cancelText="Cancelar"
                    // cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

                    // onOk={() => {
                    //     validarBeneficio();
                    // }}
                    // okText="Incluir"
                    // okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
                    footer={[
                        <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
                            {estadoModal === 2 ? "Fechar" : "Cancelar"}
                        </Button>,
                        <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
                            key="ok" type="primary" onClick={validarBeneficio}>
                            {estadoModal === 3 ? "Alterar" : "Incluir"}
                        </Button>,
                    ]}
                >

                    <Row>
                        <Col xs={24} md={24} xl={24}>
                            <Form.Item label="Nome"
                                name="nmBeneficio"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Preencha o Nome do Benefício",
                                    },
                                ]}
                            >
                                <Input
                                    disabled={manter === 2 ? true : false}
                                    placeholder="Nome"
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Tipo"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmTpBeneficio"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Selecione um Tipo de Benefício",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? true : false}
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    placeholder='Tipo Benefício'
                                    onChange={(_, index) => {
                                        handleTipoBeneficio(index);
                                    }}
                                >
                                    {listTiposBeneficios.map((e: ITipo) => (
                                        <Select.Option key={e.id} value={e.nome}>
                                            {e.nome}
                                        </Select.Option>
                                    ))}
                                </Select>

                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Fundamentação Regulamentar"
                                name="fdRegulamentar"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Preencha a Fundamentação Regulamentar",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Fundamentação"
                                    disabled={manter === 2 ? true : false}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Regime Financeiro"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmRegimeFinanceiro"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Selecione um Regime Financeiro",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? true : false}
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    placeholder='Regime Financeiro'
                                    options={listRegimeFinanceiro}
                                    onChange={(_, index) => {
                                        handleRegimeFinanceiro(index);
                                    }}
                                />

                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Método de Financiamento"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmMetodoFinanciamento"
                                colon={false}
                                rules={[
                                    {
                                        required: nmRegimeFinanceiro.toUpperCase().includes("IZAÇÃO"),
                                        message: "Selecione um Método de Financiamento",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? true : !nmRegimeFinanceiro.toUpperCase().includes("IZAÇÃO")}
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    placeholder='Metodo de Financiamento'
                                    options={listMetodoFinanciamento}
                                    onChange={(_, index) => {
                                        handleMetodoFinanciamento(index);
                                    }}
                                />

                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Tipo de Expressão do Benefício"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmTpExpressaoBeneficio"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Selecione um Tipo de Expressão do Benefício",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? true : false}
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    placeholder='Tipo de Expressão do Benefício'
                                    options={listTipoExpressaoBeneficio}
                                    onChange={(_, index) => {
                                        handleTipoExpressaoBeneficio(index);
                                    }}
                                />

                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24} xl={12}>
                            <Form.Item label="Prazo de Pagamento"
                                labelAlign="left"
                                labelCol={{ span: 20 }}
                                name="nmPrazoPagamento"
                                colon={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Selecione um Prazo de Pagamento",
                                    },
                                ]}
                            >
                                <Select
                                    disabled={manter === 2 ? true : false}
                                    showSearch
                                    filterOption
                                    optionFilterProp='children'
                                    placeholder='Prazo de Pagamento'
                                    options={listPrazoPagamento}
                                    onChange={(_, index) => {
                                        handlePrazoPagamento(index);
                                    }}
                                />

                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>

                        <Col xs={24} md={12} xl={10}>
                            <div>
                                <h4>Prevê Reserva Atuarial</h4>
                                <Checkbox
                                    disabled={manter === 2 ? true : false}
                                    checked={reservaAtuarialAcumulacao}
                                    onChange={onChangeReservaAtuarialAcumulacao}>Fase de Acumulação</Checkbox>
                                <Checkbox
                                    disabled={manter === 2 ? true : false}
                                    checked={reservaAtuarialConcessao}
                                    onChange={onChangeReservaAtuarialConcessao}>Fase de Concessão</Checkbox>
                            </div>
                        </Col>

                        <Col xs={24} md={12} xl={10}>
                            <div>
                                <h4></h4>
                                <Checkbox
                                    disabled={manter === 2 ? true : false}
                                    checked={beneficioFacultativo}
                                    onChange={onChangeBeneficioFacultativo}>Benefício Facultativo</Checkbox>
                                <Checkbox
                                    disabled={manter === 2 ? true : false}
                                    checked={riscoSeguradora}
                                    onChange={onChangeRiscoSeguradora}>Prevê Transferência de riscos para seguradora</Checkbox>
                            </div>
                        </Col>

                        <Col xs={24} md={12} xl={10}>
                            <div>
                                <h4></h4>
                                <Checkbox
                                    disabled={manter === 2 ? true : false}
                                    checked={beneficioMinimo}
                                    onChange={onChangeBeneficioMinimo}>Possui Benefício Mínimo</Checkbox>
                            </div>
                        </Col>
                    </Row>

                    <Tabs
                        defaultActiveKey="1"
                        items={items}
                    // onChange={onChange} 
                    />
                </Modal>

                <Row style={{ display: exibirBeneficiosCadastrados }}>
                    <Col
                        xs={24}
                        sm={24}
                    >
                        <Table
                            size="small" rowKey="nome" columns={columns} dataSource={objetoBeneficio} pagination={false} />
                    </Col>
                </Row>
            </>
        </Form>
    )
};

export default Beneficio;

